export enum CallType {
    DIRECT,
    GROUP,
    BUSINESS,
}
